import { Paper, Typography, Stack, Alert, Box, Collapse } from "@mui/material";
import { useState } from "react";
import useUpdateQuestion from "../Hooks/useUpdateAuditQuestion";
import useDeleteQuestion from "../Hooks/useDeleteAuditQuestion";
import Actions from "../Common/Actions";
import TitleForm from "../Common/TitleForm";
import Droppable from "../Common/Droppable";
import Draggable from "../Common/Draggable";
import QuestionForm from "./QuestionForm";
import QuizIcon from '@mui/icons-material/LiveHelp';
import { txt } from "../../../services/translation";

export default function Question({data, choices, dragged}){

    const [titleForm, setTitleForm] = useState(data.edit ? true : false)

    const [form, setForm] = useState(false)

    const [drag, setDrag] = useState(false)

    const updateQuestion = useUpdateQuestion()
    const deleteQuestion = useDeleteQuestion()

    const handleNewTitle = title => {
        setTitleForm(false)
        updateQuestion({...data, title})
    }

    const handleChange = question => {
        setForm(false)
        updateQuestion(question)
    }

    return <>

        <Stack>

            <Draggable id={data.id} data={{...data, isQuestion: true}} disabled={!drag}>

                <Paper
                    variant='outlined'
                    sx={{p: 1}}
                    data-id={data.id}
                    data-rank={data.rank}
                >
                    {titleForm ?
                        <TitleForm
                            title={data.title}
                            onSubmit={handleNewTitle}
                            onCancel={() => setTitleForm(false)}
                        />
                        :
                        <Stack direction='row' alignItems='center' spacing={1}>
                            
                            <QuizIcon color='action' sx={{width: 20}} />

                            <Box sx={{flex:1}} onClick={() => setTitleForm(true)}>
                                {data.title ? 
                                    <Typography>{data.title}</Typography>
                                    :
                                    <Alert severity='warning'>{txt('addTitle')}</Alert>
                                }
                            </Box>

                            <Actions
                                onEdit={() => setForm(true)}
                                onDelete={() => deleteQuestion(data.id)}
                                onDrag={() => setDrag(true)}
                                onDrop={() => setDrag(false)}
                            />
                        </Stack>
                    }

                    <Collapse direction="down" in={form} mountOnEnter unmountOnExit>
                        <QuestionForm
                            question={data} 
                            onSubmit={handleChange}
                            onCancel={() => setForm(false)}
                        />
                    </Collapse>

                </Paper>

            </Draggable>

            <Droppable 
                id={data.id} 
                data={{rank: data.rank + 0.5, isQuestion: true}}
                disabled={!dragged?.isQuestion|| dragged?.id === data.id}
            />

        </Stack>

    </>
}